export default "__VITE_ASSET__BY_qaNyc__"